import { Typography } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/ProductosConfirmacion.scss';

import React, { Component } from 'react';
import SwitchComponent from './SwitchComponent';

export default class ProductoConfirmarCuentaComponent extends Component {
  onSwitchChange = (value, index) => {
    if (this.props.switchChange) {
      this.props.switchChange(value, index);
    }
  };

  renderProductos = (productos) => {
    const result = productos.map((item, index) => {
      return (
        <div key={index}>
          <div className="lineaCredito">
            <div className="lineaCreditoTitulo">
              <Typography className="tituloBold">{item.nombreProducto}</Typography>
            </div>
            <SwitchComponent
              checked={item.selected}
              onChange={(value) => {
                this.onSwitchChange(value, index);
              }}
            />
          </div>
        </div>
      );
    });
    return result;
  };
  render() {
    return (
      <div className="ProductoConfirmar ">
        <div className="tituloProducto">
          <Typography className="tituloStepSolicitudAcordeon">{this.props.tituloProducto}</Typography>
        </div>
        {this.renderProductos(this.props.productos)}
      </div>
    );
  }
}
